import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import RegisterLibraryItemCommand from './commands/register-library-item-command';
import AddLibraryItemCommand from './commands/add-library-item-command';

export default class InsertLibraryItemEditing extends Plugin {
  init() {
    this.editor.commands.add(
      'registerLibraryItem',
      new RegisterLibraryItemCommand(this.editor)
    );

    this.editor.commands.add(
      'addLibraryItem',
      new AddLibraryItemCommand(this.editor)
    );
  }
}
